import React from 'react'
import Select from 'react-select'
import R from 'ramda'

import PoiTop from './PoiTop'
import PoiBottom from './PoiBottom'

const Poi = ({poi, zoom, viewPort, map, options, index, onToggle, onDelete, onChange, onToggleEditFrequency, onSelect}) => {

  const topProps = {
    poi, 
    options, 
    onDelete: _ => onDelete(index),
    onSelect: _ => onSelect(poi, zoom, viewPort, map),
    onChange,
    index,
  }
  const bottomProps = {
    options, 
    poi,
    onChange,
    onToggleEditFrequency,
    index,
  }
  const isOpen = poi.isOpen
  const iconName = poi.isOpen ? '\u25B2' : '\u25BC'
  const anchorToggle = _ => onToggle(index);
  
  const className =  isOpen ? "poi-open poi-box" : "poi-closed poi-box"
  return <div className={className}>
    <PoiTop {...topProps}/>
    {isOpen && poi.type == 0 ? <PoiBottom {...bottomProps}/> : null}
    { R.not(poi.type) ?
         <a onClick={anchorToggle} className="btn-more btn btn-primary" style={{textTransform: "initial", boder:'1px', padding:'1px'}}>          
            {iconName}
         </a>
        : null
        }
  </div>
}
Poi.propTypes = {
  poi: React.PropTypes.object.isRequired,
  index: React.PropTypes.number.isRequired,
  options: React.PropTypes.object.isRequired,
  onToggle: React.PropTypes.func.isRequired,
  onToggleEditFrequency: React.PropTypes.func.isRequired,
  onDelete: React.PropTypes.func.isRequired,
  onChange: React.PropTypes.func.isRequired,
  onSelect: React.PropTypes.func.isRequired,
}
export default Poi



/** WEBPACK FOOTER **
 ** ./app/components/Poi.jsx
 **/